import React from "react";
import "../css/Sidebar.css";
import SidebarRow from "./SidebarRow";
import EmojiFlagsIcon from "@material-ui/icons/EmojiFlags";
import { useStateValue } from "../StateProvider";

function Sidebar() {
  const [{ user, userProfile }] = useStateValue();

  return (
    <div className="sidebar">
      <SidebarRow src={user.photoURL} title={userProfile && userProfile.name} />
      <SidebarRow Icon={EmojiFlagsIcon} title="Pages" />
      <SidebarRow Icon={EmojiFlagsIcon} title="Friends" />
      <SidebarRow Icon={EmojiFlagsIcon} title="Messenger" />
      <SidebarRow Icon={EmojiFlagsIcon} title="Market Place" />
    </div>
  );
}

export default Sidebar;
